import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, UrlTree } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { AuthService } from '@app/services/auth.service';
import { HeaderComponent } from '@app/common/header/header.component';
import { HttpService } from '@app/services/http.service';
import { STRINGS } from '@app/services/constants';

@Component({
  selector: 'app-page-verify',
  imports: [
    HeaderComponent,
    MatButtonModule,
    MatProgressSpinnerModule,
    RouterLink,
  ],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss',
})
export class ConfirmComponent implements OnInit {
  STR = STRINGS;

  confirmed = signal<null | boolean>(null);
  loading = signal<boolean>(false);
  result!: string;
  redirection = signal<null | UrlTree>(null);

  private authService = inject(AuthService);
  private http = inject(HttpService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit() {
    this.result = this.route.snapshot.queryParams['result'];
    if (this.result === 'success') {
      this.confirmed.set(true);
      void this.signin();
    } else {
      this.confirmed.set(false);
      this.redirection.set(this.router.createUrlTree(['/enrol']));
    }
  }

  async signin() {
    const { access_token, refresh_token } = this.route.snapshot.queryParams;
    if (access_token && refresh_token) {
      this.http.storeTokens({ access_token, refresh_token });
      try {
        this.loading.set(true);
        await this.authService.reloadUser();
        this.redirection.set(this.router.createUrlTree(['/enrol']));
      } catch (e) {
        this.redirection.set(
          this.router.createUrlTree(['/signin'], {
            queryParams: { redirect: '/enrol' },
          }),
        );
      } finally {
        this.loading.set(false);
      }
    } else {
      this.redirection.set(this.router.createUrlTree(['/enrol']));
    }
  }
}
